import { render, staticRenderFns } from "./BaseDateInput.vue?vue&type=template&id=ea87e558&"
import script from "./BaseDateInput.vue?vue&type=script&lang=js&"
export * from "./BaseDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports